import React, { ReactNode } from "react";
import {
  Pressable,
  ScrollView,
  StyleSheet,
  useWindowDimensions,
} from "react-native";
import { useTheme } from "react-native-paper";
import { useScreenSize } from "../hooks/useScreenSize";
import { SafeAreaView } from "react-native-safe-area-context";

interface ModalScreenWrapperProps {
  onClose: () => void;
  children: ReactNode;
  renderActionButtons?: () => ReactNode;
  modalWidth?: number;
}

export default function ModalScreenWrapper({
  onClose,
  children,
  renderActionButtons,
  modalWidth = 800,
}: ModalScreenWrapperProps) {
  const theme = useTheme();
  const { LARGE_SCREEN } = useScreenSize();
  const { height } = useWindowDimensions();

  if (LARGE_SCREEN) {
    return (
      <Pressable style={styles.overlay} onPress={onClose}>
        <Pressable
          style={{
            minWidth: modalWidth,
            maxWidth: modalWidth,
            maxHeight: height * 0.9,
            alignSelf: "center",
            backgroundColor: theme.colors.background,
          }}
          onPress={(e) => e.stopPropagation()}
        >
          <ScrollView
            style={[
              styles.container,
              { backgroundColor: theme.colors.background },
            ]}
          >
            {LARGE_SCREEN && renderActionButtons?.()}
            {children}
          </ScrollView>
        </Pressable>
      </Pressable>
    );
  }

  return (
    <ScrollView>
      <SafeAreaView
        style={{
          padding: 16,
        }}
        edges={["bottom"]}
      >
        {children}
      </SafeAreaView>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    justifyContent: "center",
    paddingHorizontal: 20,
  },
  container: {
    padding: 16,
  },
});
